import { buildModelManager } from "../builder.js";
const DefaultShopifyFulfillmentSelection = {
  __typename: true,
  id: true,
  createdAt: true,
  deliveredAt: true,
  displayStatus: true,
  estimatedDeliveryAt: true,
  inTransitAt: true,
  locationId: true,
  name: true,
  notifyCustomer: true,
  orderId: true,
  originAddress: true,
  receipt: true,
  requiresShipping: true,
  service: true,
  shipmentStatus: true,
  shopId: true,
  shopifyCreatedAt: true,
  shopifyUpdatedAt: true,
  status: true,
  statusBackup: true,
  totalQuantity: true,
  trackingCompany: true,
  trackingInfo: true,
  trackingNumber: true,
  trackingNumbers: true,
  trackingUrl: true,
  trackingUrls: true,
  updatedAt: true,
  variantInventoryManagement: true
};
const modelApiIdentifier = "shopifyFulfillment";
const pluralModelApiIdentifier = "shopifyFulfillments";
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultShopifyFulfillmentSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultShopifyFulfillmentSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultShopifyFulfillmentSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultShopifyFulfillmentSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultShopifyFulfillmentSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultShopifyFulfillmentSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultShopifyFulfillmentSelection,
    namespace: null
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "shopifyFulfillmentGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
operations.push(...[
  "create",
  "bulkCreate",
  "update",
  "bulkUpdate",
  "delete",
  "bulkDelete"
].map((operation) => ({
  type: "stubbedAction",
  functionName: operation,
  errorMessage: `The action ${operation} on model shopifyFulfillment does not have an api trigger and cannot be called from this api client. If you are the developer of this application and want api clients to call this action add an api trigger to the action. For more information see: https://docs.gadget.dev/guides/actions/triggers`,
  operationName: "",
  dataPath: "",
  actionApiIdentifier: operation,
  modelApiIdentifier,
  variables: {},
  reason: "MissingApiTrigger"
})));
const ShopifyFulfillmentManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultShopifyFulfillmentSelection,
  operations
);
export {
  DefaultShopifyFulfillmentSelection,
  ShopifyFulfillmentManager
};
//# sourceMappingURL=ShopifyFulfillment.js.map
